<style lang="scss">
.app-header {
  width: 100vw;
  background-color: white !important;

  &__name {
    font-size: 14pt;
  }

  img {
    border-right: 1px solid $border-color;
  }

  &__links a {
    color: black !important;
  }
}
</style>

<template>
  <v-app-bar v-if="!hideUi" class="app-toolbar app-header" fixed dense height="64px" max-height="64px">
    <img class="pointer pr-3" @click="$router.push({name: 'Home'})" width="60px" src="../assets/logo.png" alt="">
    <p class="app-header__name mb-0 ml-4">Books</p>

    <v-spacer></v-spacer>

    <section class="app-header__links" v-if="$route.name === 'Home'">
      <a class="d-inline mr-1" href="#query-section">Popular |</a>
      <a class="d-inline mr-1" href="#visual-search">Search |</a>
      <a class="d-inline mr-1" href="#recommend-block">Recommendations</a>
    </section>
  </v-app-bar>
</template>

<script>
import {mapState} from 'vuex';

export default {
  name: 'App-Header',
  props: [''],
  components: {},
  computed: {
    darkMode: {
      get() {
        return this.$store.state.darkMode
      },
      set(value) {
        this.$store.commit('SET_DARK_MODE', value)
      }
    },
    ...mapState({
      hideUi: state => state.hideUi,
    })
  },
  data() {
    return {
      dark: false
    };
  },
  mounted() {

  },
  methods: {
    scrollToFavourites() {
      var favourites = document.querySelector('.favourites-section');

      if (favourites) {
        favourites.scrollIntoView();
      }
    },
  },
};
</script>
